import {
  FETCH_ALL_USERS_FAILURE,
  FETCH_ALL_USERS_REQUEST,
  FETCH_ALL_USERS_SUCCESS,
} from "./actionsTypes";
import { AllUsersState } from "./types";

const initialState: AllUsersState = {
  allUsers: [],
  loadingScreen: false,
  error: null,
  successMessage: "",
  pending: false,
};

const allUsersReducer = (state = initialState, action: any): AllUsersState => {
  switch (action.type) {
    case FETCH_ALL_USERS_REQUEST:
      return {
        ...state,
        loadingScreen: false,
        error: null,
      };
    case FETCH_ALL_USERS_SUCCESS:
      return {
        ...state,
        loadingScreen: false,
        allUsers: action.payload.allUsers,
      };

    case FETCH_ALL_USERS_FAILURE:
      return {
        ...state,
        loadingScreen: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default allUsersReducer;
